class CardVariants extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.formInput = this.form?.querySelector("input[name=id]");
    this.formId = this.dataset.formId;
    this.inputs = this.querySelectorAll(".variant-input");
    this.productHandle = this.dataset.productHandle;
    this.productVariants = JSON.parse(
      this.querySelector(`#card-${this.productHandle}`)?.textContent
    );
    this.shopMoneyFormat = this.dataset.shopMoneyFormat;
    this.variantPriceElm = this.querySelector(".variant-price");
    this.inputs.forEach((input) => {
      input.addEventListener("change", this.onVariantChange.bind(this));
    });
  }

  onVariantChange(event) {
    event.preventDefault();
    let selectedVariantId = event.target.id;
    this.formInput.value = selectedVariantId;

    this.updatePrice(selectedVariantId);
  }

  updatePrice(variantId) {
    let variant = this.productVariants.find(
      (variant) => variant.id == variantId
    );
    let variantPrice;
    variantPrice = this.formatMoney(variant.price);
    this.variantPriceElm.textContent = variantPrice;
  }

  formatMoney(amount) {
    let regExp = /\{([^)]+)\}/g;
    let match = this.shopMoneyFormat.match(regExp)[0];
    let amountMoney;

    switch (match) {
      case "{{amount}}":
        amountMoney = (amount / 100).toFixed(2);
        break;
      case "{{amount_with_comma_separator}}":
        amountMoney = (amount / 100).toFixed(2).replace(".", ",");
        break;
      default:
        amountMoney = amount / 100;
    }

    let amountMoneyString = this.shopMoneyFormat.replace(match, amountMoney);
    return amountMoneyString;
  }
}

customElements.define("card-variants", CardVariants);
